
import AddCompForm from "../../components/Forms/AddCompForm";
import BasicCard  from "../BasicCard";
import Dummylayout from "../Dummylayout";



function AddComp() {
    return (
        <>
            <Dummylayout/>
            <BasicCard>
               <AddCompForm/>
            </BasicCard>
        </>
    )
}
export default AddComp;